import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { delay, Subject } from 'rxjs';
import { PageContainerService } from '../../services/page-container.service';
import { HeaderComponent } from '../header/header.component';

@Component({
    selector: 'app-page-container-header',
    standalone: true,
    imports: [RouterOutlet, HeaderComponent],
    templateUrl: './page-container-header.component.html',
    styleUrl: './page-container-header.component.scss'
})
export class PageContainerHeaderComponent implements OnInit, OnDestroy {

    private readonly pageContainerService = inject(PageContainerService);
    private readonly onDestroy$ = new Subject<void>();
    private _footerName?: string;

    protected footerVisible: boolean = false;
    protected get footerClassName(): string | undefined {
        return this._footerName ? `with-footer--${this._footerName}` : undefined;
    }

    ngOnInit(): void {
        this.pageContainerService.footerVisible$
            .pipe(
                delay(0)
            )
            .subscribe(footerVisibilityResult => {
                this.footerVisible = footerVisibilityResult.visible;
                this._footerName = footerVisibilityResult.name;
            });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

}
